export const hyInputs:any = {
  // device_config: {
  //   D: 3.6,// 塔内径 (m)
  //   hw: 0.05, //出口堰的高度（m）
  //   lw: 2.27,//出口堰的长度 (m)
  //   A_d_ratio: 1.22 / ((Math.PI * 3.6 * 3.6) / 4), //降液管面积比 降液管面积/塔截面积
  //   phi_hole: 1.02 / ((Math.PI * 3.6 * 3.6) / 4), // 开孔率=开孔面积/塔截面积
  //   d_o: 0.005,//筛板孔径 (m)
  //   tp: 0.0025,//筛板厚度（m）
  //   H_T: 0.6, // 相邻塔板间的距离，影响塔高和允许气速（m）
  //   hb: 0.04, //降液管底部与塔板的距离（m）
  //   delta: 0, //液面落差（m）
  //   phi: 0.5,// 泡沫相对密度 （kg/m³）
  //   tau_min: 3, // 最小停留时间（s）
  //   h_ow_target: 0.006, // 堰液头目标值（m）
  // },
  // stream_config: {
  //   L_op: 100000, //液相质量流量（kg/h）
  //   V_op: 120000, //气相质量流量（kg/h）
  //   rhoL_op: 694, // 液体密度（kg/m³）
  //   rhoV_op: 2.69, // 气体密度（kg/m³）
  //   sigma_op: 21, // 液体表面张力（mN/m）
  // }
"device_config":{"D":2.2,"Wtop":0.3,"Wb":0.22,"hw":0.053,"hb":0.044,"phi_hole":0.1,"d_o":0.0127,"tp":0.00342,"H_T":1,"delta": 0.0,"phi":0.5,"tau_min":3.0,"h_ow_target":0.006},
"stream_config":{"L_op":40243.90,"V_op":28103.40,"rhoL_op":879.61,"rhoV_op":1.70,"sigma_op":51.26
  }
}

// 输入参数映射
export const hyParamsMap:any = {
  D:{ label:"塔内径",unit:"m"},
  hw:{ label:"出口堰的高度",unit:"m"},
  lw:{ label:"出口堰的长度",unit:"m"},
  A_d_ratio:{ label:"降液管面积比",unit:""},
  phi_hole:{ label:"开孔率",unit:""},
  d_o:{ label:"筛板孔径",unit:"m"},
  tp:{ label:"筛板厚度",unit:"m"},
  H_T:{ label:"相邻塔板间距",unit:"m"},
  hb:{ label:"降液管底部与塔板的距离",unit:"m"},
  delta:{ label:"液面落差",unit:"m"},
  phi:{ label:"泡沫相对密度",unit:"kg/m³"},
  tau_min:{ label:"最小停留时间",unit:"s"},
  h_ow_target:{ label:"堰液头目标值",unit:"m"},
  L_op:{ label:"液相质量流量",unit:"kg/h"},
  V_op:{ label:"气相质量流量",unit:"kg/h"},
  rhoL_op:{ label:"液体密度",unit:"kg/m³"},
  rhoV_op:{ label:"气体密度",unit:"kg/m³"},
  sigma_op:{ label:"液体表面张力",unit:"mN/m"},
  Wtop:{ label:"Wtop",unit:""},
  Wb:{ label:"Wb",unit:""},
}